import api from './api';

export interface Carts {
    id: string;
    user_id: string;
    bought: number;
    clip_id: number;
    court_location:string;
    court_name: string;
    download_count: string;
    merchant_name:string;
    merchant_address:string;
    price: number;
    watermarked_url: string;
    storage_url: string;
    created_at: string;
    // Add other Video properties as needed
}

export const cartsService = {
    // Fetch all Videos
    async fetchCartsByUserId(): Promise<Carts[]> {
        const user_id = JSON.parse(localStorage.getItem('user'))?.id;
        const response = await api.get<Carts[]>(`/carts/user/${user_id}`, { 
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
             } 
        });
        return response.data;
    },
    // create transaction
    async addToCart(data: { user_id: string; clip_id: number}): Promise<Carts> {
        const response = await api.post<Carts>('/carts/add', data, { 
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
             } 
        });
        return response.data;
    },
    // add to library if video is free
    async addToLibrary(data: { user_id: string; clip_id: number}): Promise<Carts> {
        const response = await api.post<Carts>('/carts/add/library', data, { 
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
             } 
        });
        return response.data;
    },
    // delete cart item
    async deleteCart(cartID:string): Promise<void> {
        const user_id = JSON.parse(localStorage.getItem('user'))?.id;
        await api.delete<void>(`/carts/${cartID}/user/${user_id}`, { 
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
             } 
        });
    },

    async clearCart(): Promise<void> {
        const user_id = JSON.parse(localStorage.getItem('user'))?.id;
        await api.delete<void>(`/carts/user/${user_id}/clear`, { 
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
             } 
        });
    }
}